import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Small } from 'foundations-components/transitional/components/Small';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { SERVICE } from 'self-service-api/constants/ProductLines';
import { HighlightedProductsHeaderConfig } from '../../constants/merchCards/HighlightedProductsHeaderConfig';
import HubProductCTA from '../../features/purchaseMotions/components/HubProductCTA';
import { useHubPurchaseMotions } from '../../features/purchaseMotions/hooks/useHubPurchaseMotions';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import withErrorBoundary from '../error-boundary/withErrorBoundary';
import { PriceDisplayContainer } from '../merch-card/price-display/PriceDisplayContainer';
import { useSkuAdditionalUnits } from '../merch-card/useSkuAdditionalUnits';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValuePropositionsUpgradeCard = ({
  trackingSource,
  productLine = SERVICE,
  productLevel = PROFESSIONAL
}) => {
  const isAppReady = useGlobalLoading();
  const {
    skuId
  } = useSkuAdditionalUnits({
    productLevel,
    productLine
  });
  const apiName = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }).apiName);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const purchaseMotions = useHubPurchaseMotions({
    skuId
  });
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const {
    title = ''
  } = HighlightedProductsHeaderConfig[productLine][productLevel] || {};
  return /*#__PURE__*/_jsxs(CardWrapper, {
    inlineSize: "100%",
    maxInlineSize: "328px",
    paddingInline: "700",
    paddingBlock: "800",
    display: "flex",
    flexDirection: "column",
    gap: "600",
    "data-test-id": `${apiName}-merch-card`,
    "data-selenium-id": `${apiName}-merch-card`,
    children: [/*#__PURE__*/_jsx(Text, {
      whiteSpace: "nowrap",
      as: "h2",
      typography: "heading-300",
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    }), /*#__PURE__*/_jsxs(CardSection, {
      padding: "0",
      display: "flex",
      gap: "600",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !isAppReady,
          heights: [20, 33],
          widths: [60, 80],
          children: /*#__PURE__*/_jsx(PriceDisplayContainer, {
            skuId: skuId,
            queryParamTerm: queryParamTerm,
            apiName: apiName
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(HubProductCTA, Object.assign({
          purchaseMotion: purchaseMotions[0],
          skuId: skuId,
          productLine: productLine,
          trackingSource: trackingSource,
          use: "primary",
          purchaseMotionLocation: "MERCH_CARD"
        }, ctaVariantProps))
      }), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.info.card.disclaimer"
        })
      })]
    })]
  });
};
export default withErrorBoundary(ValuePropositionsUpgradeCard, {
  fallback: null,
  errorBoundaryName: 'ValuePropositionsUpgradeCard'
});